/** @format */

import Page from 'src/components/Page';
import { Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { Button } from 'src/components';
import { useTranslation } from 'react-i18next';

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <Page title={t('errorpage.pageTitle')} className="page-404-container">
      {/* <div className="not-found-container"> */}
      {/* <img src={NotFoundImg} alt=""/> */}
      <div className="text-container-404">
        <p className="not-found-title">404</p>
        {/* <p>Page not found</p> */}
        <p className="not-found-text">{t('errorpage.text')}</p>

        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Link to="/">
            <Button secondary label={t('common.button.backToHome')} />
          </Link>
        </Box>
        {/* </div> */}
      </div>
    </Page>
  );
}
